import { Context } from "@baseline/runtime";
import * as baseline from "@baseline/ui/routing/legacy";
import { MainRouter } from "./main-router";


export class RoutingService extends baseline.RoutingManager
{
    constructor(
        readonly context: Context
    )
    {
        super();
    }

    override start(): void
    {
        const mainRouter = MainRouter.build(this.context);
        this.addRouter(mainRouter);

        super.start();
    }
}
